import * as React from "react";

;
export const SwitchOff = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={48} height={24} fill="none" {...props}><rect width={48} height={24} fill="#CFCDD3" rx={12} /><circle cx={12.5} cy={12} r={10.5} fill="#fff" /></svg>;